// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1907":"57c37739","3156":"b52c6e6f","4823":"57c37739","9955":"e4176dbf"}[chunkId] + ".chunk.css";
};